<form #formResetPassword="ngForm" id="enterPassword" name="formResetPassword" (submit)="handleSubmitResetPassword(formResetPassword.value, $event)" novalidate>
  <h3 class="page__heading text-dark-blue margin-bottom-24">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>

  <div class="panel">
    <div class="panel__header">{{ appCopy.panelHeader["btnSetPassword" + selectedLanguage] }}</div>
    <div class="panel__body">
      <div class="section">
        <p class="text-muted text-dark-blue">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
      </div>
      <div class="section section__colored">
        <div class="passwordIcon">
        <div class="form-group margin-bottom-16">
          <input class="form-control" [ngClass]="{ 'has-error' : Password.invalid && Password.dirty }" id="Password"
            name="Password" [type]="showPassword.password ? 'text' : 'password'"#Password="ngModel" [(ngModel)]="passwordValues.password1" ngModel
            required appCheckEmpty placeholder="{{
              appCopy.panelHeader['loginPasswordLabel' + selectedLanguage]
            }}"/>
            <div class="btntoggle" (click)="togglePasswordVisibility('password')">
              <ng-container *ngIf="showPassword.password; else showPass">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showPass>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="
              Password.invalid && Password.dirty && !Password?.errors?.pattern
            ">
            {{ appCopy.panelHeader["warningEnterPassword" + selectedLanguage] }}
          </p>
        </div>

        <div class="form-group margin-bottom-16">
          <div class="passwordIcon">
          <input class="form-control" [ngClass]="{ 'has-error' : PasswordVerify.invalid && PasswordVerify.dirty }" id="PasswordVerify"
            name="PasswordVerify" [type]="showPassword.confirmPassword ? 'text' : 'password'" #PasswordVerify="ngModel" [(ngModel)]="passwordValues.password2" ngModel
            required appCheckEmpty placeholder="{{
              appCopy.panelHeader['loginRePasswordLabel' + selectedLanguage]
            }}"
            (ngModelChange)="passwordsEqual()"/>
            <div class="btntoggle" (click)="togglePasswordVisibility('confirmPassword')">
              <ng-container *ngIf="showPassword.confirmPassword; else showConfirm">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showConfirm>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="PasswordVerify.invalid && PasswordVerify.dirty">{{ appCopy.panelHeader['warningReEnterPassword'+selectedLanguage] }}</p>
          <p class="help-block text-danger" *ngIf="!passwordMatch">{{ appCopy.panelHeader['warningMatchPassword'+selectedLanguage] }}</p>
        </div>
      </div>

      <div class="section section__actions">
        <div class="flex flex--justify-content-center text-center">
          <button type="submit" class="btn btn-purple btn-lg" [disabled]="formResetPassword.invalid || showLoader">
            <div class="loader-container-btn" *ngIf="showLoader">
              <div class="loader loader--white">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" />
                </svg>
              </div>
            </div>
            {{ appCopy.panelHeader['btnSetPassword'+selectedLanguage] }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <p class="text-dark-blue">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <div class="form-group">
    <input class="form-control"
            [ngClass]="{ 'has-error' : Password.invalid && Password.dirty }"
            id="Password"
            name="Password"
            type="password"
            #Password="ngModel"
            [(ngModel)]="passwordValues.password1"
            ngModel
            required
            appCheckEmpty>
    <label class="control-label" for="Password">{{ appCopy.panelHeader['loginPasswordLabel'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>

    <p class="help-block text-danger" *ngIf="Password.invalid && Password.dirty">{{ appCopy.panelHeader['warningEnterPassword'+selectedLanguage] }}</p>
  </div>

  <div class="form-group">
    <input class="form-control"
            [ngClass]="{ 'has-error' : PasswordVerify.invalid && PasswordVerify.dirty || !passwordMatch }"
            id="PasswordVerify"
            name="PasswordVerify"
            type="password"
            #PasswordVerify="ngModel"
            [(ngModel)]="passwordValues.password2"
            (ngModelChange)="passwordsEqual()"
            ngModel
            required
            appCheckEmpty>
    <label class="control-label" for="PasswordVerify">{{ appCopy.panelHeader['loginRePasswordLabel'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>

    <p class="help-block text-danger" *ngIf="PasswordVerify.invalid && PasswordVerify.dirty">{{ appCopy.panelHeader['warningReEnterPassword'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="!passwordMatch">{{ appCopy.panelHeader['warningMatchPassword'+selectedLanguage] }}</p>
  </div> -->

  <!-- <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formResetPassword.invalid || showLoader">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnSetPassword'+selectedLanguage] }}
  </button> -->

</form>
